"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHLQATasksBulkEditModalAutocomplete = exports.StyledHLQATasksBulkEditModalFields = exports.StyledHLQATasksBulkEditModalContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const autocomplete_selector_1 = require("../../../../components/autocomplete-selector");
exports.StyledHLQATasksBulkEditModalContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  min-width: 420px;
`;
exports.StyledHLQATasksBulkEditModalFields = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing(2)};
`;
exports.StyledHLQATasksBulkEditModalAutocomplete = (0, styled_components_1.default)((autocomplete_selector_1.AutocompleteSelector)) `
  width: 100%;

  && .MuiAutocomplete-root > .MuiFormControl-root > .MuiInputBase-root.MuiOutlinedInput-root {
    border-radius: 4px;
    min-height: ${({ theme }) => theme.spacing(6)};
  }

  && .MuiAutocomplete-root > .MuiFormControl-root > .MuiInputBase-root .MuiAutocomplete-input {
    padding-top: ${({ theme }) => theme.spacing(0.5)};
    padding-bottom: ${({ theme }) => theme.spacing(0.5)};
  }
`;
